import { useEffect } from "react";

export function SEO({ title, description, path = "/", image = "/images/fleet/fleet-04.webp", schema }) {
  useEffect(() => {
    document.title = title;
    const setMeta = (key, value, property = false) => {
      const selector = property ? `meta[property="${key}"]` : `meta[name="${key}"]`;
      let node = document.querySelector(selector);
      if (!node) {
        node = document.createElement("meta");
        node.setAttribute(property ? "property" : "name", key);
        document.head.appendChild(node);
      }
      node.setAttribute("content", value);
    };
    const canonicalUrl = `${window.location.origin}${path}`;
    setMeta("description", description);
    setMeta("robots", "index, follow, max-image-preview:large");
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", canonicalUrl, true);
    setMeta("og:image", `${window.location.origin}${image}`, true);
    setMeta("twitter:card", "summary_large_image");
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
    let script = document.getElementById("page-schema");
    if (!script) {
      script = document.createElement("script");
      script.id = "page-schema";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  }, [title, description, path, image, schema]);
  return null;
}